import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { planDayDate } from '../rolloutDayCopy';
import { reelsPlanMessages } from './reelsPlanMessages';
import type { ReelsPlanSummary } from './reelsPlanModel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the AI reels plan; each part uses its own slice of it */
import styles from './ReelsPlan.module.scss';
/* eslint-enable css-modules/no-unused-class */

const bold = (chunks: React.ReactNode[]) => <b>{chunks}</b>;

interface ReelsPlanSummaryLineProps {
  summary: ReelsPlanSummary;
}

/**
 * The summary line of the setup (design rollout-plan f1): "7 reels · 7 video credits · 21 posts
 * (7 reels × 3 channels that take a video), from Tue 8 Jun to Sun 20 Jun". The numbers are the
 * numbers of the dry run.
 */
const ReelsPlanSummaryLineComponent: React.FC<ReelsPlanSummaryLineProps> = ({ summary }) => {
  const intl = useIntl();
  const { reels, credits, posts, channels, from, to } = summary;
  return (
    <span className={styles.sum} data-testid="reels-plan-summary">
      {from === null || to === null
        ? intl.formatMessage(reelsPlanMessages.summaryReels, { reels, b: bold })
        : intl.formatMessage(reelsPlanMessages.summary, {
            reels,
            credits,
            posts,
            channels,
            from: planDayDate(intl, from),
            to: planDayDate(intl, to),
            b: bold,
          })}
    </span>
  );
};

export const ReelsPlanSummaryLine = TypedMemo(ReelsPlanSummaryLineComponent);
